
define(
	'Tavanoteam.PLPAddToCart.PLPAddToCart'
,   [
		'jQuery'
	,	'underscore'
	]
,   function (
		jQuery
	,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var plp = container.getComponent('PLP');

			if(plp)
			{

				//Show 'Choose Options' for Matrix Items instead of 'Add To Cart'
				plp.addToViewContextDefinition('Cart.QuickAddToCart.View', 'isMatrix', 'boolean', function(context){

					var isMatrix = false;

					var itemInfo = plp.getItemsInfo() ? plp.getItemsInfo() : [];
				
					_.each(itemInfo, function(item) {

						if(item.internalid == context.itemId) {	

							var noChild = _.isEmpty(item.matrixchilditems_detail);

							//IF ITEM HAS CHILD ITEMS
							if(!noChild) {
								isMatrix = true;
							}
							else {
								isMatrix = false;
							}
						}
						
					});

					return isMatrix;

				});

				//Construct and render Item URL
				plp.addToViewContextDefinition('Cart.QuickAddToCart.View', 'itemUrl', 'string', function(context){

					var itemUrl = '/';

					var itemInfo = plp.getItemsInfo() ? plp.getItemsInfo() : [];

					_.each(itemInfo, function(item) {

						if(item.internalid == context.itemId) {	

							//ITEM URL
							itemUrl= item.keyMapping_url;

						}
						
					});

					return itemUrl;

				});

			}

		}
	};
});
